import { render, staticRenderFns } from "./ActionShare.vue?vue&type=template&id=6a32fd47&"
import script from "./ActionShare.vue?vue&type=script&lang=js&"
export * from "./ActionShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports